<div class="carousel">
  <div class="slides">
    <ng-container *ngFor="let slide of slides; let i = index">
      <app-image
        [src]="slide.url"
        [alt]="slide.text"
        *ngIf="i === slideInView"
        [@fadeInOut]
        class="slide"
        (swipeleft)="onNextClick()"
        (swiperight)="onPreviousClick()"
      >
      </app-image>
    </ng-container>
  </div>
</div>
<div class="thumbnails__wrapper">
  <div class="thumbnails" #thumbnails>
    <ng-container *ngFor="let slide of slides; let i = index">
      <div
        class="thumbnail"
        (click)="onThumbnailClick(i)"
        [class.thumbnail--active]="activeSlide === i"
      ></div>
    </ng-container>
  </div>
</div>
<div class="content__wrapper">
  <ng-container *ngFor="let slide of slides; let i = index">
    <div *ngIf="i === slideInView">
      <h4>{{ slide.title }}</h4>
      <p class="font--sm">
        {{ slide.text }}
      </p>
    </div>
  </ng-container>
</div>
<div class="cta__wrapper">
  <button
    (click)="this.closed.emit(CloseModalType.Skip)"
    class="cta cta--small"
    [disabled]="activeSlide === slides?.length - 1"
  >
    Skip
  </button>
  <button (click)="onNextClick(true)" class="cta cta--small">
    {{ activeSlide === slides?.length - 1 ? 'Finish' : 'Next' }}
  </button>
</div>
